import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import ChainIcon from "../chain_icon";
import PolygonIcon from "../polygon_icon";
import Auctions_dropdown from "../dropdown/Auctions_dropdown";
import { useDispatch, useSelector } from "react-redux";
import { buyModalShow } from "../../redux/counterSlice";

const blockchainIcons = {
  // vitruveo: <ChainIcon />,
  polygon: <PolygonIcon />,
};

const CategoryItem = ({ data, isCollection }) => {
  const dispatch = useDispatch();
  return (
    <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
      {data?.length ? (
        data?.map((item) => {
          return (
            <article key={item.id}>
              <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                <figure className="relative">
                  <Link href={`/poet/${item?.token_id}`}>
                    <a>
                      <img
                        src={
                          item?.display_image
                            ? item?.display_image
                            : item?.poet?.poet_detail?.display_media_url
                        }
                        alt="item 5"
                        className="w-full h-[230px] rounded-[0.625rem] object-cover"
                      />
                    </a>
                  </Link>

                  {!isCollection && blockchainIcons[item?.poet?.chain_name]}

                  {/* <div className="absolute left-3 -bottom-3">
                    <div className="flex -space-x-2">
                      <Link href={`/poet/${item?.id}`}>
                        <a>
                          <Tippy
                            content={
                              <span>creator: {item?.art_detail?.artist}</span>
                            }
                          >
                            <img
                              src={""}
                              alt="creator"
                              className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                            />
                          </Tippy>
                        </a>
                      </Link>
                      <Link href={`/poet/${item?.id}`}>
                        <a>
                          <Tippy
                            content={
                              <span>creator: {item?.art_detail?.artist}</span>
                            }
                          >
                            <img
                              src={""}
                              alt="owner"
                              layout="fill"
                              className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                            />
                          </Tippy>
                        </a>
                      </Link>
                    </div>
                  </div> */}
                </figure>
                <div className="mt-7 flex items-center justify-between">
                  <Link href={`/poet/${item?.token_id}`}>
                  {/* <Link href={`/issuer/poet/${item?.art_detail?.id}`}> */}
                    <a className="poet-thumbnail">
                      <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                        {item?.poet?.poet_detail?.title
                          ? item?.poet?.poet_detail?.title
                          : item?.name}
                      </span>
                    </a>
                  </Link>

                  {/* auction dropdown  */}
                  {!isCollection && (
                    <Link href={`/poet/${item?.token_id}`}>
                      <button
                        className="text-accent font-display text-sm font-semibold"
                        // onClick={() => dispatch(buyModalShow())}
                      >
                        View more
                      </button>
                    </Link>
                  )}
                  {/* <Auctions_dropdown classes="dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full " /> */}
                </div>
                {/* <div className="mt-8 flex items-center justify-between"> */}
                {/* <Link href={`/poet/${item?.id}`}>
                    <button
                      className="text-accent font-display text-sm font-semibold"
                      // onClick={() => dispatch(buyModalShow())}
                    >
                      View more
                    </button>
                  </Link> */}
                {/* <Link href={`/poet/${item?.id}`}>
                    <a className="group flex items-center">
                      <svg className="icon icon-history group-hover:fill-accent dark:fill-jacarta-200 fill-jacarta-500 mr-1 mb-[3px] h-4 w-4">
                        <use xlinkHref="/icons.svg#icon-history"></use>
                      </svg>
                      <span className="group-hover:text-accent font-display dark:text-jacarta-200 text-sm font-semibold">
                        View History
                      </span>
                    </a>
                  </Link> */}
                {/* </div> */}
              </div>
            </article>
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};

export default CategoryItem;
